module.exports = __webpack_public_path__ + "images/icons_v2/filter-outlined-83852bb1.svg";